import { ITreatment } from '@/Models/ITreatment';
import { ITypedValidationResult } from '@/Models/IValidationResult';
import { BaseApiService } from './base-api-service';

class treatmentService extends BaseApiService {
    public constructor() {
		super('treatment/');
    }

	public async getByPhaseId(phaseId: number): Promise<ITreatment[]> {
		return this.httpClient.get<ITreatment[]>(`GetByPhaseId/${phaseId}`).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }
    
	public async save(dto: ITreatment): Promise<ITypedValidationResult<ITreatment>> {
		return this.httpClient.post<ITypedValidationResult<ITreatment>>("save", dto).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
	}

	public async delete(id: number): Promise<void> {
		return this.httpClient.delete<void>(`delete/${id}`).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
	}
}

export const TreatmentService: treatmentService = new treatmentService();